import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appInputNumber]'
})
export class InputNumberDirective {

  @Input('intOnly') intOnly: boolean = false;
  // solo si esta activo intOnly
  @Input('maxLenght') maxLenght: number = 0;

  constructor(private el: ElementRef) { }

  // usamos esta directiva para los input que incluyen numeros, de momento solo sirve para prevenir otras teclas en caso de un input int

  numberOnlyKeyCodes = [    96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];

  // keypad, numbers, left-right, backspace, supr
  intOnlyKeyCodes = [46, 8, ...this.numberOnlyKeyCodes, 37, 39];

  @HostListener('keydown', ['$event']) onKeyPressed(e: KeyboardEvent) {
    if (this.intOnly) {
      if (!this.intOnlyKeyCodes.includes(e.keyCode)) {
        e.preventDefault();
      }
      if (this.maxLenght !== 0 && !(this.el.nativeElement.value.toString().length < this.maxLenght) && this.numberOnlyKeyCodes.includes(e.keyCode)) {
        e.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/input-number-directive.ts